<template>
  <div class="buy-center page">
    <!-- <div style="margin-left: 40px; font-size: 20px">
      <i class="el-icon-arrow-left"
         style="cursor: pointer"
         @click="$router.push('/home')">返回</i>
    </div> -->
    <div class="wrapper">
      <div class="my-set-meal"
           v-if="companyInfo">
        <!-- <h2>我的套餐</h2> -->
        <p style="margin-bottom: 10px">
          公司名称：
          <span v-if="companyInfo.companyName">{{
            companyInfo.companyName
          }}</span>
          <span v-else
                class="to_set_button"
                @click="$router.push('/user')">前往设置</span>
        </p>
        <div>
          <p>
            当前版本：<span>{{ "免费版" }}</span>
          </p>
          <!-- &nbsp;<a href="/buyPoint" style="color:coral;text-decoration: underline;">(去充点数)</a>&nbsp; -->

          <p v-if="companyInfo.vipEndDate">
            到期时间：<span>{{ companyInfo.vipEndDate }}</span>
          </p>
        </div>
      </div>
      <div v-if="mealList.length <= 0"
           style="text-align: center; width: 100%; font-size: 16px">
        <i class="el-icon-loading"
           style="font-size: 28px"></i>
        数据加载中,请稍候...
      </div>
      <ul class="set-meal"
          v-else>
        <li :class="{ current: curIndex === index }"
            v-for="(item, index) in mealList"
            :key="item.Id"
            @click="handleClick(index)">
          <div class="duration">{{ item.DurationByMonth }}<br />个<br />月</div>
          <div class="price">
            <h2 class="set-meal-title">{{ item.Title }}</h2>
            <div>
              <span class="current-price">￥{{ item.SelleMoney }}</span>
              <del class="original-price">￥{{ item.OriginalMoney }}</del>
            </div>
          </div>
          <div class="check-icon"
               v-if="curIndex === index">
            <span class="el-icon-check"></span>
          </div>
        </li>
      </ul>
      <div class="privilege">
        <div>权益</div>
        <ul v-if="this.mealList[curIndex]">
          1.此版本只对该公司员工产生收益
          <br />
          2.返佣比例为20%
          <!-- <li>
            <div class="icon">
              <img src="~/assets/img/ticket.png" alt="" />
            </div>
            <div>
              <span
                >{{
                  this.mealList[curIndex].Point
                    ? this.mealList[curIndex].Point
                    : 0
                }}点</span
              >
              <div>简历点数</div>
            </div>
          </li>
          <li>
            <div class="icon">
              <img src="~/assets/img/user-num.png" alt="" />
            </div>
            <div>
              <span>{{ this.mealList[curIndex].AccountCount }}个</span>
              <div>账号数量</div>
            </div>
          </li> -->
        </ul>
      </div>
      <div class="pay_way flex align-items-center">
        <div>支付方式：</div>
        <div class="pay"
             :class="{ cur_pay: payIndex === 1 }"
             @click="payIndex = 1">
          <img src="~/assets/img/pay2.png"
               alt="" />
          微信支付
          <div class="check-icon"
               v-if="payIndex == 1">
            <span class="el-icon-check"></span>
          </div>
        </div>
        <div class="pay"
             :class="{ cur_pay: payIndex === 0 }"
             @click="payIndex = 0">
          <img src="~/assets/img/pay1.png"
               alt=""
               style="width: 20px; margin-right: 8px" />
          支付宝支付
          <div class="check-icon"
               v-if="payIndex == 0">
            <span class="el-icon-check"></span>
          </div>
        </div>
        <el-button class="pay-btn"
                   @click="toBuy"
                   :disabled="payButtonIsDisabled">{{ payButtonText }}</el-button>
      </div>
      <div class="buyer">
        <div>
          <ul>
            <li v-for="(item, index) in buyer"
                :key="index">
              <img src="~/assets/img/avatar.png"
                   alt="" />
              <p>
                {{ item.phone }}
                <span>刚刚</span>
                购买了返佣版
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog title="订单支付"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="450px"
               class="pay_dialog"
               @close="closePayDialog">
      <div class="pay_tip">
        <h3>{{ payIndex === 0 ? "支付宝" : "微信" }}扫码支付</h3>
        <span>使用{{ payIndex === 0 ? "支付宝" : "微信" }}APP扫码完成支付</span>
      </div>
      <div class="pay_by_ewm">
        <div class="ewm">
          <img :src="QRCode"
               alt="" />
        </div>
        <div class="order_info">
          <p v-if="this.mealList[curIndex]">
            <span class="pay_product">{{ this.mealList[curIndex].Title }}-{{
                this.mealList[curIndex].DurationByMonth
              }}个月</span>
          </p>
          <p v-if="this.mealList[curIndex]">
            支付金额<br /><span class="pay_price"><i>￥</i>{{ this.mealList[curIndex].SelleMoney }}</span>
          </p>
        </div>
      </div>
      <el-button size="medium"
                 type="success"
                 @click="checkisPay"
                 class="is_pay_button">我已支付</el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      mealList: [
        {
          Id: "e06a4c07-abf6-ec11-815c-ea4f50d095b5",
          CompanyId: "00000000-0000-0000-0000-000000000000",
          Title: "返佣版",
          Describe: "包括，平台免费使用",
          LevelName: null,
          DurationByMonth: 12,
          Point: 1,
          AccountCount: 3,
          OriginalMoney: 4888,
          SelleMoney: 3888,
          PromotionText: null,
          Sort: 5,
          IsPutMarket: true,
          CreateUserId: "b86ea9fd-5dd2-ec11-8113-b5e92844409f",
          CreateUserName: "",
          CreateDate: "2022-06-28T14:24:57.377",
          UpdateUserId: "b86ea9fd-5dd2-ec11-8113-b5e92844409f",
          UpdateUserName: "",
          UpdateDate: "2022-07-15T11:14:45.423",
        },
        {
          Id: "eb43c559-aaf6-ec11-815c-ea4f50d095b5",
          CompanyId: "00000000-0000-0000-0000-000000000000",
          Title: "超级版",
          Describe: null,
          LevelName: null,
          DurationByMonth: 12,
          Point: 200,
          AccountCount: 3,
          OriginalMoney: 5888,
          SelleMoney: "待定",
          PromotionText: null,
          Sort: 2,
          IsPutMarket: true,
          CreateUserId: "b86ea9fd-5dd2-ec11-8113-b5e92844409f",
          CreateUserName: "",
          CreateDate: "2022-06-28T14:20:06.247",
          UpdateUserId: "b86ea9fd-5dd2-ec11-8113-b5e92844409f",
          UpdateUserName: "",
          UpdateDate: "2022-07-15T11:21:05.88",
        },
      ],
      curIndex: 0,
      payIndex: 1,
      payButtonIsDisabled: false,
      companyInfo: null,
      QRCode: "",
      orderNo: "",
      buyer: [
        {
          phone: "137******36",
          duration: 12,
        },
        {
          phone: "135******26",
          duration: 6,
        },
        {
          phone: "157******35",
          duration: 24,
        },
        {
          phone: "199******96",
          duration: 1,
        },
        {
          phone: "136******87",
          duration: 12,
        },
        {
          phone: "159******56",
          duration: 1,
        },
        {
          phone: "137******36",
          duration: 12,
        },
        {
          phone: "134******78",
          duration: 12,
        },
        {
          phone: "137******87",
          duration: 24,
        },
        {
          phone: "188******25",
          duration: 1,
        },
        {
          phone: "156******89",
          duration: 6,
        },
        {
          phone: "188******34",
          duration: 1,
        },
        {
          phone: "137******36",
          duration: 12,
        },
        {
          phone: "135******26",
          duration: 6,
        },
        {
          phone: "157******35",
          duration: 24,
        },
        {
          phone: "199******96",
          duration: 1,
        },
        {
          phone: "136******87",
          duration: 12,
        },
        {
          phone: "159******56",
          duration: 1,
        },
      ],
      timer: "",
    };
  },
  computed: {
    payButtonText: function () {
      var textArray = ["去支付", "请稍候..."];
      var text = this.payButtonIsDisabled ? textArray[1] : textArray[0];
      return text;
    },
  },
  created () {
    // this.getSetMealList();
    this.CompanyDetail();
  },
  methods: {
    getSetMealList () {
      this.$api.setMeal.getSetMealList().then((res) => {
        if (res.Error === false) {
          this.mealList = res.Data;
        }
      });
    },
    handleClick (index) {
      this.curIndex = index;
    },
    toBuy () {
      const sendData = {
        OrderType: "VIP订单",
        ProductId: this.mealList[this.curIndex].Id,
        ProductName: this.mealList[this.curIndex].Title,
        DurationByMonth: this.mealList[this.curIndex].DurationByMonth,
        Price: this.mealList[this.curIndex].SelleMoney,
        PayWay: this.payIndex === 1 ? "微信" : "支付宝",
      };
      this.payButtonIsDisabled = true;
      if (this.payIndex === 1) {
        this.toBuyByWeChat(sendData);
      } else {
        this.toBuyByAlipay(sendData);
        setTimeout(() => {
          this.payButtonIsDisabled = false;
        }, 5000);
      }
    },
    toBuyByAlipay (sendData) {
      this.$api.setMeal.createVipOrder(sendData).then((res) => {
        if (res.Code === 0) {
          const div = document.createElement("div");
          div.innerHTML = res.Data.qRCode;
          document.body.appendChild(div);
          document.forms.alipaysubmit.setAttribute("target", "_blank");
          document.forms.alipaysubmit.submit();
        }
      });
    },
    toBuyByWeChat (sendData) {
      this.$api.setMeal.createVipOrder(sendData).then((res) => {
        if (res.Error === false) {
          this.QRCode = res.Data.qRCode;
          this.orderNo = res.Data.orderNo;
          this.dialogVisible = true;
          this.timer = setInterval(() => {
            this.checkisPay();
          }, 30000);
        } else {

        }
      });
    },
    checkisPay () {
      if (!this.orderNo) return;
      const sendData = {
        orderType: 1,
        orderNo: this.orderNo,
      };
      this.$api.setMeal.checkPayState(sendData).then((res) => {
        if (res.Code === 0) {
          this.$message.success("支付成功");
          this.dialogVisible = false;
          this.CompanyDetail();
        }
      });
    },
    closePayDialog () {
      this.QRCode = "";
      this.orderNo = "";
      clearInterval(this.timer);
      this.payButtonIsDisabled = false;
    },
    CompanyDetail () {

      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.companyInfo = res.data;

        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: auto !important;
}
.buy-center {
  height: calc(100vh - 155px);
}
.wrapper {
  width: 1020px;
  margin: 60px auto;
}
.my-set-meal {
  // background-color: #f8f8f8;
  border: 1px solid #ebeef5;
  padding: 20px;
  margin: 20px 0;
  h2 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  > div {
    display: flex;
    p {
      margin-right: 50px;
      span {
        font-weight: 600;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.set-meal {
  display: flex;
  .set-meal-title {
    font-size: 20px;
    margin-bottom: 12px;
    font-weight: 600;
  }
  li {
    display: flex;
    width: 240px;
    margin-right: 20px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:last-child {
      margin-right: 0;
    }
    .duration {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 50px;
      min-height: 84px;
      font-weight: 600;
      text-align: center;
      border: 1px solid #ddd;
      border-radius: 6px 0 0 6px;
      font-size: 13px;
      box-sizing: border-box;
    }
    .price {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      border: 1px solid #ddd;
      border-left: none;
      border-radius: 0 6px 6px 0;
      box-sizing: border-box;
      .current-price {
        margin-right: 5px;
        font-size: 21px;
        font-weight: 600;
        margin-bottom: 8px;
        letter-spacing: 1px;
      }
      .original-price {
        color: #999;
        font-size: 13px;
      }
    }
    .check-icon {
      width: 100px;
      position: absolute;
      bottom: 0;
      right: -44px;
      background-color: #cea257;
      text-align: center;
      transform: rotate(-40deg);
      > span {
        color: #fff;
        transform: rotate(35deg);
        margin-left: -5px;
      }
    }
  }
  .current {
    .duration {
      border-color: #cea257;
      border-width: 2px;
    }
    .price {
      border-color: #cea257;
      border-width: 2px;
      .current-price {
        color: #f94842;
      }
    }
    .set-meal-title {
      color: #cea257;
    }
  }
}
.privilege {
  padding: 20px;
  // background-color: #F8F8F8;
  border: 1px solid #ebeef5;
  margin: 20px 0;
  > div {
    font-size: 17px;
    margin-bottom: 5px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      display: flex;
      align-items: center;
      margin-top: 10px;
      padding: 0 24px;
      border-right: 1px solid #ccc;
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        border-right: none;
      }
      .icon {
        img {
          width: 32px;
          margin-right: 10px;
        }
      }
      > div {
        font-size: 13px;
        div {
          margin-top: 3px;
          color: #999;
        }
      }
    }
  }
}
.pay_way {
  .pay {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    margin-left: 20px;
    width: 150px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    img {
      width: 25px;
      margin-right: 5px;
    }
    .check-icon {
      width: 50px;
      position: absolute;
      bottom: -1px;
      right: -23px;
      background-color: #efbc7e;
      transform: rotate(-40deg);
      span {
        position: relative;
        top: -3px;
        color: #fff;
        font-size: 12px;
        transform: rotate(35deg);
        margin-left: -12px;
        text-align: start;
      }
    }
  }
  .cur_pay {
    border-color: #efbc7e;
  }
  .pay-btn {
    background-color: #cea257;
    border: none;
    color: #fff;
    margin-left: 100px;
    &:hover {
      opacity: 0.8;
    }
  }
}
.buyer {
  // background-color: #f8f8f8;
  border: 1px solid #ebeef5;
  padding: 20px;
  margin-top: 30px;
  > div {
    height: 165px;
    overflow: hidden;
  }
  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    animation: move 8s linear infinite;
    li {
      width: calc(50% - 30px);
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      padding: 4px 10px;
      background-color: #fff;
      border-radius: 30px;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
      p {
        font-size: 13px;
        color: #999;
        margin-left: 15px;
        span {
          color: #cea257;
          padding: 0 2px;
        }
      }
    }
  }
  @keyframes move {
    0% {
      transform: translateY(0);
    }
    50% {
      // transform: translateY(-82px);
      transform: translateY(-165px);
    }
    100% {
      // transform: translateY(-165px);
      transform: translateY(-330px);
    }
  }
}
.pay_dialog {
  .el-dialog__header {
    padding: 15px 20px;
    border: 1px solid #ddd;
  }
  .el-dialog__body {
    padding: 15px 20px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333;
  }
  .pay_tip {
    display: flex;
    align-items: flex-end;
    margin-top: 20px;
    h3 {
      font-size: 20px;
      font-weight: 500;
      margin-right: 20px;
    }
    span {
      color: #999;
    }
  }
  .pay_by_ewm {
    display: flex;
    margin-top: 15px;
    .ewm {
      text-align: center;
      img {
        width: 120px;
      }
    }
    .order_info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 20px;
      p {
        .pay_product {
          font-size: 18px;
          font-weight: 600;
        }
        .pay_price {
          font-size: 30px;
          color: #ff5328;
          font-weight: 600;
          display: inline-block;
          margin-top: 6px;
          i {
            font-size: 20px;
            font-style: normal;
          }
        }
      }
    }
  }
  .is_pay_button {
    margin-top: 20px;
  }
}
</style>